/*
 * 版权声明
 * 上海万位数字技术有限公司（以下简称“本公司”）对其自行研究开发、编写编制的软件程序、代码等（以下简称“研发资料”）均受《中华人民共和国反不正当竞争法》、《中华人民共和国著作权法》、《中华人民共和国专利法》及适用之国际公约中有关著作权、专利权及/或其他财产所有权法律的保护，为本公司专属或持有。
 * 使用者将本公司专属或持有的研发资料用于商业、营利、广告性目的时，需事先征得本公司书面特别授权，并注明出处“上海万位数字技术有限公司”，并按照有关国际公约及中华人民共和国法律的有关规定，向本公司支付使用费。
 * 未经本公司事先明确的书面特别授权，任何单位或个人不得以任何形式、任何途径，通过任何渠道变更、篡改、发行、发布、散布、复制、重制、展示或利用研发资料全部或部分内容，否则以侵权论，依法追究法律责任。
 *
 * Copyright Notice
 * All the software programs and codes among others (hereinafter referred to as the R&D data) solely developed and written by Shanghai Wanway Digital Technology Co., Ltd. (hereinafter referred to as the Company) are protected by the Law of the People's Republic of China against Unfair Competition, Copyright Law of the People's Republic of China, Patent Law of the People's Republic of China and provisions on laws of copyrights, patent rights and/or other property ownership in international conventions that apply and exclusive to or owned by the Company.
 * While using the R&D data exclusive to or possessed by the Company for any commercial, marketing, or advertising purpose, users need ask for special authorization from the Company in writing beforehand, note the source "Shanghai Wanway Digital Technology Co., Ltd." and pay the Company royalties subject to relevant provisions in related international conventions and laws of the People's Republic of China.
 * With no prior and express written special authorization from the Company, any unit or individual shall not alter, tamper, issue, release, distribute, duplicate, remake, produce or use part or all of the R&D data in any form and any way, otherwise it shall be deemed as infringement and subject to legal penalties by law.
 */

/**
 * 搜索树中的模糊搜索
 */
import React from 'react';
import { message, AutoComplete } from 'antd';
import  Tools  from '../../../tools/Tools';

export default class MyAutoComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      optionData: [],
      selectShow: 'none',
      allParentAccount: Tools.getApiUrl('allParentUrl',this.props.platform),
      type:this.props.type,
      value:this.props.accountName || ""
    };
    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this);
    this.getAutoCompleteResult = this.getAutoCompleteResult.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.setValue = this.setValue.bind(this);
    window.setAccountname = this.setValue.bind(this);
  }

  componentDidMount() {

  }

  onSelect(value, option) {
    console.log(value,option,this.state.optionData)
    const {optionData} = this.state;
    let selectedItem = optionData.filter((option) => {
      return option.organizationId == value;
    })
    const other = selectedItem[0]; //取选中的item
    if (this.props.sendAccountId) {
      this.props.sendAccountId(other.organizationId, other.name);
    }
    if (this.props.selectName) {
      this.props.selectName(other.organizationId, other.name);
    }
    if (this.props.setAutoValue) {
      this.props.setAutoValue(other.name);
    }
    this.setState({
      value: other.name,
      selectShow: 'none'
    }, () => {
      this.getAllParentAccount(other.organizationId,other.name);
    });
  }

  getAllParentAccount(organizationId,accountName) {
    let url = this.state.allParentAccount + organizationId;
    if(!organizationId) {
      return
    }
    const that = this;
    if (that.state.type) {
      url = `${url}&type=${that.state.type}`;
    }
    Tools.fetch(url, 'GET', (data) => {
      // 将风控接口的数据进行转换
      data = Tools.dataTransferAutoComplete(data, localStorage.getItem('platform'));
      if (data && data.resultStatusBean) {
        if (data.resultStatusBean.code == 0) {
          if (data.data instanceof Array) {
            const expandedKeys = [];
            data.data.map((item) => {
              expandedKeys.push(String(item.organizationId));
            });
            that.props.positionCustomerNode(expandedKeys, String(organizationId), accountName);
          }
        } else if (data.resultBean.code == 40010) {
          message.error(data.resultBean.result);
        }
      }
    });
  }

  onChange(value) {
    if (this.props.showTree) {
      this.props.showTree('inline-block');
    }
    if (value.length > 20) {
      value = value.substr(0, 20);
    }
    this.setState({
      value
    });
    if (Tools.isNull(value)) {
      this.setState({
        selectShow: 'none',
        optionData:[]
      });
      return;
    }
    let len = 0;
    for (let i = 0; i < value.length; i++) {
      if (value.charCodeAt(i) > 127 || value.charCodeAt(i) == 94) {
        len += 2;
      } else {
        len++;
      }
    }
    if (len > 2) {
      this.getAutoCompleteResult(value);
    }
  }

  getAutoCompleteResult(value) {
    let url = '';
    if (this.props.searchUrl) { // 搜索结果5条
      url = this.props.searchUrl + value;
    }
    if (this.props.rootAccountId) { // 自定义围栏，组合行政区域围栏搜索
      url += `&parentId=${this.props.rootAccountId}`;
    }
    if (this.state.type) {
      url = `${url}&type=${this.state.type}`;
    }
    Tools.fetch(url, 'GET', (data) => {
      // 将风控接口的数据进行转换
      data = Tools.dataTransferAutoComplete(data, localStorage.getItem('platform'));
      if (data && data.resultStatusBean.code == 0) {
        this.setState({
          optionData: data.data,
          selectShow: (data.data && data.data.length > 0) ? 'block' : 'none'
        });
      } else if (data && data.resultStatusBean.code === 40010) {
        message.error(data.resultStatusBean.result);
      }
    }, (message) => { console.log(message); });
  }

  onFocus() {
    if (this.props.showTree) {
      this.props.showTree(true);
    }
  }

  onBlur() {
    this.setState({
      selectShow: 'none'
    });
    if (this.props.setInputChangeF) {
      this.props.setInputChangeF(true);
    }
    if (this.props.setAutoValue) {
      this.props.setAutoValue(this.state.value);
    }
  }

  setValue(data) {
   this.setState({
      value: data
    });
  }

  render() {
    const { selectShow, optionData, value } = this.state;
    // 客户搜索
    const option = optionData.map((item, index) => {
      const content = item.name;
      const parentName = item.parentName;
      let title = parentName?`${content}（${parentName}）`:`${content}`;
      if(item.userAccount && parentName) {
        title = item.name + `（${item.userAccount}；${item.parentName}）`
      }
      return  {
        value: item.organizationId,
        label: title
      }
    });
    const { width, hideLabel ,treeName} = this.props;
    const that = this;
    return (
      <div className="customer_select_search_input" id={"search_input_"+treeName}>
        {!hideLabel?<label className={"label"}> {Strings.rs10668}</label>:null}
        <AutoComplete
            combobox
            options={option}
          placeholder={Strings.rs10011}
          allowClear={false}
          notFoundContent={null}
          defaultActiveFirstOption={false}
          dropdownMatchSelectWidth={false}
          selectShow={{ display: selectShow }}
          showArrow={true}
          filterOption={false}
          showSearch={true}
          onSelect={that.onSelect}
          onSearch={that.onChange}
          onBlur={that.onBlur}
          onFocus={that.onFocus}
          suffixIcon={<i className={"iconfont icon-sousuo"}></i>}
          dropdownStyle={{
            zIndex:999999999
          }}
          value={value}
          disabled={this.props.disabled}
          getPopupContainer={()=>document.getElementById("search_input_"+treeName)}/>
      </div>
    );
  }
}
